module.exports = __webpack_public_path__ + "img/WSD.ad034226.png";